export const TextField = ({ label, value, onChange, testId, type = "text", placeholder = "", hint }) => (
  <div className="space-y-1.5">
    <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</label>
    <input
      data-testid={testId}
      type={type}
      value={value || ""}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      className="w-full rounded-xl border border-slate-300 bg-white px-3.5 py-2.5 text-sm text-slate-900 outline-none transition-colors focus:border-sky-500 focus:ring-2 focus:ring-sky-100 disabled:bg-slate-50 disabled:text-slate-400"
    />
    {hint && <p className="text-xs text-slate-400">{hint}</p>}
  </div>
);

export const AreaField = ({ label, value, onChange, testId, rows = 3, placeholder = "", hint }) => (
  <div className="space-y-1.5">
    <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</label>
    <textarea
      data-testid={testId}
      rows={rows}
      value={value || ""}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      className="w-full rounded-xl border border-slate-300 bg-white px-3.5 py-2.5 text-sm text-slate-900 outline-none transition-colors focus:border-sky-500 focus:ring-2 focus:ring-sky-100 resize-y disabled:bg-slate-50 disabled:text-slate-400"
    />
    {hint && <p className="text-xs text-slate-400">{hint}</p>}
  </div>
);

export const Card = ({ title, subtitle, children, badge }) => (
  <div className="rounded-2xl border border-slate-200/80 bg-white p-5 sm:p-6 shadow-sm">
    {(title || badge) && (
      <div className="mb-4 flex items-start justify-between gap-3">
        <div>
          {title && <h3 className="font-heading text-base font-semibold text-slate-800">{title}</h3>}
          {subtitle && <p className="mt-0.5 text-xs text-slate-500">{subtitle}</p>}
        </div>
        {badge && <span className="shrink-0 rounded-full bg-sky-50 px-2.5 py-1 text-[11px] font-semibold text-sky-700 border border-sky-100">{badge}</span>}
      </div>
    )}
    <div className="space-y-4">{children}</div>
  </div>
);
